import LineSeparator from './LineSeparator';

export {LINE_SEPARATOR_HEIGHT} from './LineSeparator.style';
export default LineSeparator;
